import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAsterisk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAsterisk"><Path d="M12.0007 2.5V21.5M3.77344 7.25L20.2279 16.75M3.77412 16.75L20.2286 7.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAsterisk;
